export const CONSTANTS = {
  NUMBER_SUFFIX: ['', 'K', 'M', 'B', 'T'],
  BLACK_HEX_CODE: '#000000',
  HEADER_LABEL: 'PRICING SIMULATOR',
  DASHBOARD_INFO: 'Ease in RGM planning and analysis through interactive scenarios',
  TOOL_VERSION: '1.0',
  PATH: {
    LOGIN: 'login',
    LANDING: 'landing',
    ADMINPANEL: 'admin-panel',
    SCENARIOLIBRARY: 'scenario-library',
    SCENARIOCREATION: 'scenario-creation',
    SCENARIORESULT: 'scenario-result',
  },
  API: {
    GETALLSCENARIOLIBRARYDATA: 'api/scenarioLibrary',
    DYNAMIC_FILTERS: 'dynamic_filters/',
    NIELSEN_DATA: 'nielsen_performance/',
    REVENUE_DATA: 'revenue_performance/',
    SPEECH_RECOGNITION: 'speech_recognition/',
    STATE_METRIC: 'state_metric/',
    BRAND_DATA: 'brand_and_volume_mix_table/',
    SEGMENT_DATA: 'input_filters/',
    STATES_PACK_SEGMENTS: 'states_with_available_pack_segments/',
    INPUT_KPI: 'input_kpi_calculation/',
    METRIC_FILTERS: 'metric_values_for_filters/',
    SCENAIO_CREATION: 'create_scenario/',
    SCENARIO_OVERVIEW: 'scenario_overview/',
  },
  ERROR: 'Something Went Wrong.',
  MORE_INFO:
    ' A planning tool, which can create a Pack/Price scenarios based on conjoint survey outputs for vertical pricing, new launch and replacement of the product for India market at State/Bottler level.',
};
